/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Macos_4Inputs */

const en_pc_dl_macos_4 = /** @type {(inputs: Pc_Dl_Macos_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want terminal automation too? Grab the separate CLI .zip.`)
};

const zh_pc_dl_macos_4 = /** @type {(inputs: Pc_Dl_Macos_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还需要终端自动化？另外下载 CLI 的 .zip 包。`)
};

/**
* | output |
* | --- |
* | "Want terminal automation too? Grab the separate CLI .zip." |
*
* @param {Pc_Dl_Macos_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_macos_4 = /** @type {((inputs?: Pc_Dl_Macos_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Macos_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_macos_4(inputs)
	return zh_pc_dl_macos_4(inputs)
});
export { pc_dl_macos_4 as "pc.dl.macos.4" }